import { render, staticRenderFns } from "./tableKoreksiAbsen.vue?vue&type=template&id=72485b62&scoped=true"
import script from "./tableKoreksiAbsen.vue?vue&type=script&lang=js"
export * from "./tableKoreksiAbsen.vue?vue&type=script&lang=js"
import style0 from "./tableKoreksiAbsen.vue?vue&type=style&index=0&id=72485b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72485b62",
  null
  
)

export default component.exports